import { render, staticRenderFns } from "./OrdersPage.vue?vue&type=template&id=a945adfe&scoped=true"
import script from "./OrdersPage.vue?vue&type=script&lang=js"
export * from "./OrdersPage.vue?vue&type=script&lang=js"
import style0 from "./OrdersPage.vue?vue&type=style&index=0&id=a945adfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a945adfe",
  null
  
)

export default component.exports